<template>
    <div class="row" v-if="result!==undefined && result.length > 0">
      <div class="col-md-12">
        <h4 class="text-default">{{ reward }}</h4>
      </div>
      <div class="col-md-12" v-for="(item, i) in result" :key="i">
        <h4 class="text-default">{{ getName(item) }}</h4>
        <div class="gun-block" v-if="item=='Gun won'">
          <VideoBlock :link="result[i+1]" />
        </div>
      </div>
    </div>
</template>

<script>
import VideoBlock from "../components/VideoBlock.vue";
import ApiService from "@/services";
export default {
  name: "Result",
  props: ["result","reward"],
  components: {
    VideoBlock,
  },
  methods: {
    getName(item){
      if(item=="Just tokens"){
        return "Token earned."
      }else if(item=="Gun won"){
        return "You found a new gun from the bank";
      }else if(item=="FIRARM"){
        return "Fire Arm Craft Item earned..";
      }else if(item=="PISTREV"){
        return "Pistal Revolver Craft Item earned.";
      }else if(item=="DYNMT"){
        return "Dynamite won.";
      }else{
        return this.gameItemNames(item);
      }
    },
    gameItemNames(item){
      this.gameItems = ApiService.gameItemList();
      if(!this.gameItems){
        return this.gameItems[item];
      }else{
        return item;
      }
    },
  },
};
</script>
<style scoped>
.gun-block{
  width: 73px;
    margin: 0 auto;
}
</style>